import { Component, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_ExcuseSetup } from "./shared/data.service";
import { UserService } from "../../../shared";
import { AdminSetupAddExcuseComponent } from "./admin-setup-add-excuse/admin-setup-add-excuse.component";
import { AdminSetupEditExcuseComponent } from "./admin-setup-edit-excuse/admin-setup-edit-excuse.component";
import { SchoolService } from "../../../shared/services/school.service";
import { ConfirmationService } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { Table } from "primeng/table";

@Component({
	selector: "caass-excuse-setup",
	templateUrl: "./excuse-setup.component.html",
	styleUrls: ["./excuse-setup.component.css"],
})
export class ExcuseSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private ExcuseSetupService: DataService_ExcuseSetup,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngAfterViewInit() {
		this.onSetFilterDefaults();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	@ViewChild("mydt") mydt: Table;

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;
	ToggleText: string = "Deactivate Excuse";

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	School: any;
	lstSchool: any = [];

	//Main
	SelectedExcuse: any;
	lstExcuse: any = [];

	//Filter lists
	lstIsExcusedInd: any = [];
	lstIsCountAsPresent: any = [];
	lstDefinedByDesc: any = [];
	lstSchoolName: any = [];
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ExcuseDesc", header: "Description" },
		{ field: "ExcuseCD", header: "Code" },
		{ field: "IsExcusedInd", header: "Type" },
		{ field: "IsCountAsPresent", header: "Count as Present" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
		// { field: 'SchoolName', header: 'Available To' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	onSetFilterDefaults() {
		this.mydt.filters.ActiveDesc["value"] = "Active";
	}

	loadSchools() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.School = this.lstSchool[0];

				this.loadExcuse();
			},
			(error) => {}
		);
	}

	loadExcuse() {
		this.errorMessage = "";

		if (this.School == undefined) {
			return;
		}

		this.loading = true;

		var result = this.ExcuseSetupService.LoadExcuse(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstExcuse = response;

				//Update values
				for (var i = 0; i < this.lstExcuse.length; i++) {
					var next = this.lstExcuse[i];

					next.IsExcusedInd = next.IsExcusedInd == 1 ? "Excused" : "Unexcused";
					next.IsCountAsPresent = next.IsCountAsPresent == 1 ? "Yes" : "No";
					// next.SchoolName = this.GetSchoolName(next.SchoolID)
				}

				//Load Data Filter Lists
				this.lstIsExcusedInd = Array.from(new Set(this.lstExcuse.map((item: any) => item.IsExcusedInd))).sort();
				this.lstIsCountAsPresent = Array.from(new Set(this.lstExcuse.map((item: any) => item.IsCountAsPresent))).sort();
				this.lstDefinedByDesc = Array.from(new Set(this.lstExcuse.map((item: any) => item.DefinedByDesc))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstExcuse.map((item: any) => item.SchoolName))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstExcuse.map((item: any) => item.ActiveDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	// GetSchoolName(SelectedID){
	//     if(SelectedID > 0){
	//         for(var i = 0; i < this.lstSchool.length; i++){
	//             var next = this.lstSchool[i];
	//             if(next.SchoolID == SelectedID){
	//                 return next.SchoolName;
	//                 break;
	//             }
	//         }
	//     }

	//     return "District";
	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadExcuse();
	}

	//Custom Button Methods
	onAddExcuse() {
		this.errorMessage = "";

		if (this.School == undefined) {
			this.errorMessage = "Select a school";
			return;
		}

		// var SchoolData: any;

		// for(var i = 0; i < this.lstSchool.length; i++){
		//     var next = this.lstSchool[i];
		//     if(next.SchoolID == this.SchoolID){
		//         SchoolData = next
		//     }
		// }

		var ref = this.dialogService.open(AdminSetupAddExcuseComponent, {
			header: "Add Excuse",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedSchool: this.School,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadExcuse();
			}
		});
	}

	onEditExcuse() {
		this.errorMessage = "";

		//Error handling
		if (this.School == undefined) {
			this.errorMessage = "Select a school";
			return;
		}

		if (this.SelectedExcuse == undefined) {
			this.errorMessage = "Select an excuse to edit";
			return;
		}

		//Check permission

		//NO ONE can edit System and imported excuses
		if (this.SelectedExcuse.DefinedByID <= 2) {
			this.errorMessage = "You do not have permission to edit this excuse";
			return;
		}
		//District users can edit any other excuses
		//School Users can only edit school level excuses
		if (this.user.UserLevelID == 3 && this.SelectedExcuse.DefinedByID != 3) {
			this.errorMessage = "You do not have permission to edit this excuse";
			return;
		}

		// var SchoolData: any;

		// for(var i = 0; i < this.lstSchool.length; i++){
		//     var next = this.lstSchool[i];
		//     if(next.SchoolID == this.SchoolID){
		//         SchoolData = next;
		//         break;
		//     }
		// }

		var ref = this.dialogService.open(AdminSetupEditExcuseComponent, {
			header: "Edit Excuse",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedSchool: this.School,
				SelectedExcuse: this.SelectedExcuse,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadExcuse();
			}
		});
	}

	onDeleteExcuse() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedExcuse == undefined) {
			this.errorMessage = "Select an excuse to delete";
			return;
		}

		//Check permission

		//NO ONE can edit System and imported excuses
		if (this.SelectedExcuse.DefinedByID <= 2) {
			this.errorMessage = "You do not have permission to delete this excuse";
			return;
		}
		//District users can edit any other excuses
		//School Users can only edit school level excuses
		if (this.user.UserLevelID == 3 && this.SelectedExcuse.DefinedByID != 3) {
			this.errorMessage = "You do not have permission to delete this excuse";
			return;
		}

		//Call SP
		var result = this.ExcuseSetupService.ExcuseDelete(this.SelectedExcuse.ExcuseID);
		result.subscribe(
			(response) => {
				this.onRowUnselect(null);
				if (!response) {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the Excuse",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.loadExcuse();
			},
			(error) => {
				this.onRowUnselect(null);
			}
		);
	}

	onToggleExcuse() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedExcuse == undefined) {
			this.errorMessage = "Select an excuse to deactivate";
			return;
		}

		if (this.SelectedExcuse.DefinedByID <= 2 && this.user.userID != 0) {
			this.errorMessage = "Only SU can deactivate System-Defined Excuses";
			return;
		}

		if (this.user.UserLevelID == 3 && this.SelectedExcuse.DefinedByID != 3) {
			this.errorMessage = "Only District Users can Deactivate District-Level Excuses";
			return;
		}

		var changeTo = this.SelectedExcuse.Active == true ? 0 : 1;

		//Call SP
		var result = this.ExcuseSetupService.ExcuseToggle(this.SelectedExcuse.ExcuseID, changeTo);
		result.subscribe(
			(response) => {
				this.onRowUnselect(null);
				if (!response) {
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not " + (changeTo == 1 ? "activate" : "deactivate") + " the Excuse",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
				this.loadExcuse();
			},
			(error) => {
				this.onRowUnselect(null);
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedExcuse = val.data;

		this.ToggleText = "Deactivate Excuse";
		if (this.SelectedExcuse.Active == false) {
			this.ToggleText = "Activate Excuse";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedExcuse = null;
		this.ToggleText = "Deactivate Excuse";
	}
	onRowDblClick(Excuse) {
		this.errorMessage = "";

		this.SelectedExcuse = Excuse;
		this.onEditExcuse();

		this.ToggleText = "Deactivate Excuse";
		if (this.SelectedExcuse.Active == false) {
			this.ToggleText = "Activate Excuse";
		}
	}
	onSchoolChange(val) {
		this.errorMessage = "";

		this.School = val;

		this.loadExcuse();
	}
	////////////////////////////////////////////
}
